import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import { errorMessages } from '~/constants/errorMessages.js';
import {
  isGuaranteesCounterpartyCodeLengthValid,
  normalizeGuaranteesSearchCode,
} from '../../../utils.ts';

type TGuaranteesSearchFieldValue = TAutocompleteOption | string | null;

export interface IGuaranteesSearchFormValues {
  searchCode: TGuaranteesSearchFieldValue;
}

const guaranteesSelectorValidationSchema = yup.object({
  searchCode: yup
    .mixed()
    .transform((_, originalValue) => normalizeGuaranteesSearchCode(originalValue))
    .test('search-code-format', errorMessages.INVALID_INPUT_DATA, (value) => {
      const normalizedCode = normalizeGuaranteesSearchCode(value);
      return isGuaranteesCounterpartyCodeLengthValid(normalizedCode);
    }),
});

const useSelectorForm = () => {
  return useForm<IGuaranteesSearchFormValues>({
    resolver: yupResolver(guaranteesSelectorValidationSchema) as unknown as Resolver<IGuaranteesSearchFormValues>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      searchCode: null,
    },
  });
};

export default useSelectorForm;
